import React, { useEffect, useRef } from "react";
import Mixpanel from "mixpanel-browser";
import docuploadicn from "../../assets/images/docuploadicn.svg";
import plusbtnicn from "../../assets/images/plusbtnicn.svg";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { labelDocument } from "../../features/user-document/labelDocumentSaveSlice";
import { getDocuments } from "../../features/user-document/documentListingSlice";
import { labelListing } from "../../features/user-document/label-listing";
import ConfirmationModal from "../../common/modal/ConfirmationModal";
import UploadDocumentModal from "./modal/UploadDocumentModal";
import { RoleRightsForModule } from "../../utils/utils";
import resyncImg from "../../assets/images/resync.svg";
import trashImg from "../../assets/images/trash.svg";

const DashboardHeader = ({
  title,
  setCurrentModal,
  setSubCategories,
  selectedRowsID,
  setSearchValue,
  searchValue,
  subCategories,
  perPage,
  currentPage,
  setPerPage,
  setCurrentPage = () => {},
  resyncDocument = () => {},
  handleDelete,
  currentModal,
}) => {
  let dispatch = useDispatch();
  const { labelListingData = null } = useSelector((state) => ({
    labelListingData: state?.labelListingSlice?.responseData?.label,
  }));
  /* const dropdownRef = useRef(null); */
  let projectData = JSON.parse(localStorage.getItem("_user"));
  /* let newObj = {}; */
  /* const onDropdownChange = (currentNode, selectedNodes) => {
    newObj.selected = selectedNodes;
  };
  let labelArray = []; */

  // useEffect(() => {
  //   dispatch(labelListing(projectData?.projects[0]?.uuid));
  // }, []);

  /* if (subCategories === 'Documents' && labelListingData?.length > 0) {
    function renameProperties(obj) {
      // Make a copy of the current object
      const newObj = { ...obj };

      // Rename properties of the current object
      newObj.label = newObj.name.length > 10
        ? newObj.name.slice(0, 15) + "..."
        : newObj.name;
      newObj.value = newObj.uuid;
      delete newObj.name;
      delete newObj.uuid;

      // Check for SubLabel properties
      if (newObj.SubLabel) {
        // Rename the SubLabel property
        newObj.children = newObj.SubLabel;

        // Recursively rename properties of the sub-labels
        newObj.children = newObj.children.map((subLabel) => {
          return renameProperties(subLabel);
        });

        // Delete the original SubLabel property
        delete newObj.SubLabel;
      }

      return newObj;
    }

    // Make a copy of the top-level objects and rename their properties
    if (labelListingData.length > 0) {
      // Make a copy of the top-level objects and rename their properties
      labelArray = labelListingData?.map((obj) => {
        return renameProperties(obj);
      })
    } else {
      labelArray = [];
    }
  } */

  /* const onAction = (node, action) => {
    console.log("onAction::", action, node);
  };
  const onNodeToggle = (currentNode) => {
    console.log("onNodeToggle::", currentNode);
  }; */

  /* const handleApplyLabelDocument = async () => {
    let uuidArray = [];
    let selectedLabelId = [];
    if (selectedRowsID) {
      selectedRowsID.map((data) => {
        uuidArray.push(data?.original?.uuid);
      });
    }
    newObj?.selected.forEach((data) => selectedLabelId.push(data.value));
    let { payload } = await dispatch(
      labelDocument({ document_uuid: uuidArray, label_uuid: selectedLabelId })
    );
    if (payload.status === 201) {
      dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
          search: searchValue,
        })
      );
    }
  }; */

  return (
    <div className="row align-items-center py-3">
      <div className="col-12 col-md-12 col-xl-4 col-xxl-5">
        <div className="d-flex align-items-center">
          <h5 className="intro-title">{title}</h5>
          {RoleRightsForModule("Delete", "Create Documents") &&
            RoleRightsForModule("Delete", "Upload Documents") &&
            selectedRowsID?.length > 0 && (
              <button
                type="button"
                onClick={() => {
                  setCurrentModal("multiDeleteModal");
                }}
                className="btn d-flex dlet-btn tooltip-button"
              >
                <img
                  src={trashImg}
                  alt=""
                />
                <div className="tooltip-div">
                  Delete Documents
                </div>
              </button>
            )}
          {RoleRightsForModule("Write", "Create Documents") &&
            selectedRowsID?.length > 0 && (
              <button
                type="button"
                onClick={() => resyncDocument()}
                className="btn d-flex dlet-btn ms-0 tooltip-button"
              >
                <img src={resyncImg} alt="" />
                <div className="tooltip-div">
                Retrain Documents
                </div>
              </button>
            )}
          {/* {(subCategories === "Documents" && selectedRowsID?.length > 0 && labelArray?.length > 0) && (
            <>
              <div className="dash-header-reacttree">
                <DropdownTreeSelect
                  ref={dropdownRef}
                  data={labelArray?.length > 0 ? labelArray : []}
                  onChange={onDropdownChange}
                  onAction={onAction}
                  onNodeToggle={onNodeToggle}
                  mode="multiSelect"
                  texts={{ placeholder: 'Please select label' }}
                />
              </div>
              <button
                className="apply-btn btn create-doc-btn create-doc-btn-margin  mt-0"
                onClick={() => {
                  handleApplyLabelDocument();
                }}
              >

                Apply
              </button>
            </>
          )} */}
        </div>
      </div>
      <div className="col-12 col-md-12 col-xl-8 col-xxl-7 mt-3 text-start text-xl-end mt-2 mt-xl-0">
        <div className="d-flex justify-content-start justify-content-xl-end w-100 create-doc-group">
          <div className="intro-searchbar">
            <button
              disabled
              type="submit"
              className="filter-search-btn"
            ></button>
            <input
              type="text"
              className="form-control"
              name="search"
              value={searchValue}
              placeholder="Search"
              onChange={(e) => {
                setSearchValue(e.target.value);
                setPerPage(10);
                setCurrentPage(1);
              }}
            />
            {searchValue.length > 0 && (
              <button
                type="button"
                class="btn search-reset-btn"
                onClick={() => setSearchValue("")}
              >
                <svg
                  class="close-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.414"
                  height="13.414"
                  viewBox="0 0 13.414 13.414"
                >
                  <g
                    id="Group_31758"
                    data-name="Group 31758"
                    transform="translate(0.707 0.707)"
                  >
                    <path
                      id="Path_48155"
                      data-name="Path 48155"
                      d="M0,0,12,12"
                      fill="none"
                      stroke="#313b5c"
                      stroke-width="2"
                    ></path>
                    <path
                      id="Path_48154"
                      data-name="Path 48154"
                      d="M12,0,0,12"
                      fill="none"
                      stroke="#313b5c"
                      stroke-width="2"
                    ></path>
                  </g>
                </svg>
              </button>
            )}
          </div>
          {RoleRightsForModule("Write", "Create Documents") && (
            <button
              onClick={() => {
                setSubCategories("createNewDoc");
                Mixpanel.track("Create new document Button Clicked", {
                  Page: "Dashboard page",
                });
              }}
              className="btn create-doc-btn create-doc-btn-margin  mt-0"
            >
              <img className="plusbtnicn" src={plusbtnicn} alt="plusbtnicn" />
              Create new document
            </button>
          )}
          {RoleRightsForModule("Upload", "Upload Documents") && (
            <button
              onClick={() => {
                setCurrentModal("uploadDocModal");
                Mixpanel.track("Upload new document Button Clicked", {
                  Page: "Dashboard page",
                });
              }}
              className="btn create-doc-btn mt-0 btn-primary-md"
            >
              <img
                className="docuploadicn"
                src={docuploadicn}
                alt="docuploadicn"
              />
              Upload document
            </button>
          )}
        </div>
      </div>
      {currentModal === "multiDeleteModal" && (
        <ConfirmationModal
          title={"Delete Confirmation"}
          isOpen={currentModal === "multiDeleteModal"}
          toggle={() => setCurrentModal("")}
          onConfirm={handleDelete}
          message="Are you sure you want to delete these documents?"
        />
      )}
      {currentModal === "uploadDocModal" && (
        <UploadDocumentModal
          isOpen={currentModal === "uploadDocModal"}
          toggle={() => setCurrentModal("")}
          perPage={perPage}
          currentPage={currentPage}
          setSubCategories={setSubCategories}
        />
      )}
    </div>
  );
};

export default DashboardHeader;
